import { CommonUtility } from '../common';
import { APIPath } from '../constants';
import { BaseService } from './base';
import { CRUDService } from './crud.ts';

class Wave extends CRUDService {
  constructor() {
    super(APIPath.orderWaves);
  }

  waveList(params) {
    const url = `${APIPath.orderWavesList}?${CommonUtility.objectToParams(params)}`;
    return BaseService.get(url);
  }

  orderWavesSummary(params) {
    const url = `${APIPath.orderWavesSummary}?${CommonUtility.objectToParams(params)}`;
    return BaseService.get(url);
  }

  sortedWaveList(params) {
    const url = `${APIPath.sortedOrderWavesList}?${CommonUtility.objectToParams(params)}`;
    return BaseService.get(url);
  }

  toteList(warehouseId, params) {
    const url = `${
      APIPath.orderTotes
    }/${warehouseId}/?${CommonUtility.objectToParams(params)}`;
    return BaseService.get(url);
  }

  waveRuleList(params) {
    return BaseService.get(
      `${APIPath.wavesRulesList}/?${CommonUtility.objectToParams(params)}`,
    );
  }

  markWaveReady(id) {
    return BaseService.patch(`${APIPath.orderWaves}/${id}/ready`);
  }

  moveToBuilding(id) {
    return BaseService.patch(`${APIPath.orderWaves}/${id}/building`);
  }

  addRule(data) {
    return BaseService.post(APIPath.orderWaveRules, data);
  }

  updateRule(id, data) {
    return BaseService.put(`${APIPath.orderWaveRules}/${id}`, data);
  }

  rulesMetadata() {
    return BaseService.get(APIPath.orderWaveRulesMetadata);
  }

  searchSkus(params) {
    return BaseService.get(
      `${APIPath.orderWaveRulesSkuSearch}?${CommonUtility.objectToParams(params)}`,
    );
  }

  pickWaveAllocation(waveId, allocationId, data) {
    return BaseService.post(
      `${APIPath.orderWaves}/${waveId}/allocations/${allocationId}/pick`,
      data,
    );
  }

  sortSingleItem(waveId, allocationId, data) {
    return BaseService.post(
      `${APIPath.orderWaves}/${waveId}/allocations/${allocationId}/sort`,
      data,
    );
  }

  getAllocationTote(allocaitonId) {
    return BaseService.get(`${APIPath.orderAllocationTote}/${allocaitonId}`);
  }

  createTote(data) {
    return BaseService.post(APIPath.orderTotes, data);
  }

  updateTote(data, toteId) {
    return BaseService.put(`${APIPath.orderTotes}/${toteId}`, data);
  }

  deleteTote(toteId) {
    return BaseService.remove(`${APIPath.orderTotes}/${toteId}`);
  }

  deleteWaveRule(ruleId) {
    return BaseService.remove(`${APIPath.orderWaveRules}/${ruleId}`);
  }

  assignUser(waveId, data) {
    return BaseService.post(`${APIPath.orderWaves}/${waveId}/assign`, data);
  }

  assignWavesToUser(data) {
    return BaseService.put(APIPath.wavesAssign, data);
  }

  unAssignUserFromWaves(data) {
    return BaseService.put(APIPath.wavesUnAssign, data);
  }

  generateMail(waveId, data) {
    return BaseService.post(`${APIPath.orderWaves}/${waveId}/generate-document`, data);
  }
  generateDocument(waveId, config, header) {
    return BaseService.get(
      `${APIPath.waves}/${waveId}/pdf`,
      false,
      true,
      null,
      null,
      config,
      header,
    );
  }

  generateWaveNumber(params) {
    return BaseService.get(
      `${APIPath.generaetWaveNumber}/?${CommonUtility.objectToParams(params)}`,
    );
  }

  createManualWave(params, data) {
    return BaseService.post(
      `${APIPath.waves}/?${CommonUtility.objectToParams(params)}`,
      data,
    );
  }

  deleteWave(id) {
    return BaseService.remove(`${APIPath.waves}/${id}`);
  }

  exportWave(id) {
    return BaseService.get(`${APIPath.orderWaves}/${id}/export-csv`);
  }

  getWavesExport(params) {
    return BaseService.get(
      `${APIPath.exportOrderWaves}?${CommonUtility.objectToParams(params)}`,
    );
  }

  createWavesExport(payload) {
    return BaseService.post(`${APIPath.exportOrderWaves}`, payload);
  }

  mergeWaves(payload) {
    return BaseService.post(APIPath.mergeWaves, payload);
  }

  createAllocationWave(payload) {
    return BaseService.post(APIPath.ordersWavesAllocationsBulkAdd, payload);
  }
}

const WaveService = new Wave();
Object.freeze(WaveService);
export { WaveService };
